<template>
    <div class="form-group ">
        <div class="control-label">
            <label :id="field_type" :for="'label_' + field_type">
                {{ field_name }}
            </label>
        </div>
        
        <div class="simple_text" v-if="!can_edit">
            {{ field_val }}
        </div>
        
        <div class="simple_text" v-else>
            <div class="mem_title">
                <div class="text_info  d-inline-block">
                    {{ field_val }}
                </div>
                
                
                <div class="edit_text  d-inline-block pl-1 cursor-pointer" @click="edit_text">
                    <fa :icon="faEdit"/>
                </div>
            </div>
        </div>
        
    </div>
</template>


<script>
import Fa from 'vue-fa'
import { faEdit } from '@fortawesome/free-solid-svg-icons'

export default {
    name: "mem_draw_field",
    components : {
        Fa
    },
    data() {
        return {
            faEdit
        }
    },
    props : {
        field_name : {
            type : String,
            required : true
        },
        field_type : {
            type : String,
            required : true
        },
        field_val : {
            field_name : {
                type : String | Number,
                required : true
            },
        },
        can_edit : {
            type : Boolean,
            default : false,
        }
    },
    methods : {
        edit_text() {
            this.$emit('title_edit');
        },
    }
}
</script>

<style scoped>

</style>